import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'md', className = '', text }) => {
  return (
    <div className={`loading-spinner-wrapper ${className}`} role="status" aria-label={text || "Loading"}>
      <div className={`spinner spinner-${size}`}>
        <div className="spinner-circle"></div>
      </div>
      {text && <span className="spinner-text">{text}</span>}
      <span className="sr-only">{text || "Loading..."}</span>
    </div>
  );
};

export default LoadingSpinner;
